import { toast } from "@/hooks/use-toast";
export function isUnauthorizedError(error: Error): boolean {
  return /^401: .*Unauthorized/.test(error.message);
}

// Global logout function that can be called from anywhere
let globalLogoutHandler: (() => Promise<void>) | null = null;

export function setGlobalLogoutHandler(handler: () => Promise<void>) {
  globalLogoutHandler = handler;
}

export async function handleTokenExpiration() {
  // Show toast notification
  toast({
    title: "Session Expired",
    description: "Your session has expired. Please log in again.",
    variant: "destructive",
  });

  // Call the global logout handler if available
  if (globalLogoutHandler) {
    await globalLogoutHandler();
  } else {
    // Fallback: clear localStorage and redirect
    localStorage.removeItem("user");
    setTimeout(() => {
      window.location.href = "/login";
    }, 500);
  }
}

// Redirect to login with a toast notification
export function redirectToLogin(toast?: (options: { title: string; description: string; variant: string }) => void) {
  if (toast) {
    toast({
      title: "Unauthorized",
      description: "You are logged out. Logging in again...",
      variant: "destructive",
    });
  }
  setTimeout(() => {
    window.location.href = "/login";
  }, 500);
}
